import {
  LIST_INVOICE_PATIENTS_REQUEST,
  LIST_INVOICE_PATIENTS_SUCCESS,
  LIST_INVOICE_PATIENTS_FAIL,
  HISTORY_LOG_INVOICE_PATIENTS_REQUEST,
  HISTORY_LOG_INVOICE_PATIENTS_SUCCESS,
  HISTORY_LOG_INVOICE_PATIENTS_FAIL
} from '../../constants/billing-invoices'

const initialState = {
  loading: false,
  loadingHistory: false,
  invoicePatients: [],
  history: [],
  error: '',
  pageable: {
    page: 1,
    size: 10
  }
}

const billingInvoicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_INVOICE_PATIENTS_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_INVOICE_PATIENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        invoicePatients: action.payload,
        pageable: action.pageable,
        error: ''
      }
    case LIST_INVOICE_PATIENTS_FAIL:
      return {
        ...state,
        loading: false,
        invoicePatients: action?.dummy,
        error: action.payload
      }
    case HISTORY_LOG_INVOICE_PATIENTS_REQUEST:
      return {
        ...state,
        loadingHistory: true
      }
    case HISTORY_LOG_INVOICE_PATIENTS_SUCCESS:
      return {
        ...state,
        loadingHistory: false,
        history: action.payload,
        error: ''
      }
    case HISTORY_LOG_INVOICE_PATIENTS_FAIL:
      return {
        ...state,
        loadingHistory: false,
        history: action?.dummy,
        error: action.payload
      }
    default:
      return state
  }
}

export default billingInvoicesReducer
